import {
  Action,
  getModule,
  Module,
  Mutation,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import { container } from "tsyringe";
import { CargoV2Presenter } from "@/app/ui/presenters/CargoV2Presenter";
import { CargoV2Component } from "@/app/infrastructures/dependencies/modules/CargoV2Component";
import {
  CargoV2ListRequest,
  CargoV2DisputeDownloadRequest,
  CargoV2MinimumWeightSummaryApiRequest,
  CargoV2DownloadListRequest,
  GetDetailCargoV2ForPrintParams,
  CargoV2ListClientParentApiRequest,
  CargoV2CalculateRequest,
  CargoV2SearchFlightRequest,
  AwbValidationApiRequest,
  CreateCargoV3ApiRequest,
  ScanApiRequest,
  RequestRtcList,
  RequestCheckEligibleRtcV2,
  CalculateVolumeApiRequestV2,
  CalculateVolumeRequestV2,
  CargoV2DetailActivityEnum,
  DownloadAWBRequest
} from "@/data/payload/api/CargoV2ApiRequest";
import {
  CargoSummaryInProcessRequest,
  FailedUnreadRequest,
  AddBagOrStt
} from "@/data/payload/api/CargoApiRequest";
import { EditCargoApiRequest } from "@/data/payload/api/CargoApiRequest";
import {
  CargoV2Data,
  CargoV2Entities,
  RtcListEntities,
  RtcData,
  CalculateData,
  FormCargoV2,
  CargoV2DetailStt,
  CARGO_V2_STORAGE_KEY,
  CargoV2ProductData,
  CargoV2HistoryData,
  CargoV2DisputeSummaryData,
  CargoV2FailedUnread,
  CargoV2MinimumWeightSummaryData,
  CargoV2SuccessSummaryData,
  CargoV2SummaryInProcessData,
  ListClientParentData,
  ListClientParentEntities,
  CargoV2SearchFlightResult,
  CargoV2SearchFlight,
  DimensionData,
  CalculateVolume,
  ActualDimensionData,
  DimensionPieces,
  BagOrSttDetail,
  BookingPayloadData,
  FlightRequest
} from "@/domain/entities/CargoV2";
import {
  CargoSummaryInProcessData,
  CargoFailedUnread
} from "@/domain/entities/Cargo";
import { Pagination, PaginationV2 } from "@/domain/entities/Pagination";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import parsingErrorResponse from "@/app/infrastructures/misc/common-library/ParsingErrorResponse";
import {
  dateTimePayload,
  formatDateNormal,
  formatByCountry,
  sleep,
  parseByCountry
} from "@/app/infrastructures/misc/Utils";
import { ModalMessageEntities, OptionsClass } from "@/domain/entities/MainApp";
import { FlightDetail } from "@/domain/entities/NGen";
import { flags } from "@/feature-flags";
import groupBy from "lodash/groupBy";
import {
  getDataSessionStorage,
  storeDatatoSessionStorage
} from "@/app/infrastructures/misc/Utils";
import { LocationController } from "@/app/ui/controllers/LocationController";
import { ReportController } from "@/app/ui/controllers/ReportController";
import { cloneDeep, uniqBy } from "lodash";
import {
  CALCULATE_TYPE,
  AirportRouteTypeCache,
  buildAirportRouteTypeCacheKey,
  getConfigDimensionDivider,
  getConfigIsminimumVolumePerPiece,
  getConfigMinimumVolumePerPiece,
  getDominantCommodityName,
  isPlaneRouteWithKnownCities,
  resolvePlaneBookingLimits,
  SESSION_STORAGE_CARGO_KEY
} from "../views/cargo-v2/modules/cargo-module";
import { CargoController } from "@/app/ui/controllers/CargoController";
import moment from "moment";
import { toFlightDateTimeStr } from "../views/cargo-v2/utils";
import { TAB_SUCCESS_REPORT_TYPE } from "../views/cargo-v2/modules/constants";
import router from "../router";
import { FlagsPermissionCargoV2 } from "@/feature-flags/flags-permission-cargo-v2";
import i18n from "@/i18n";
import { createI18n } from 'vue-i18n';
import en from "@/i18n/locales/en";
import translateId from "@/i18n/locales/id";
import my from "@/i18n/locales/my";

CargoV2Component.init();

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: "cargo-v2"
})
class CargoV2Store extends VuexModule {
  cargoV2List = new CargoV2Entities();
  inProgressList = new CargoV2Entities();
  inProgressPagination = new PaginationV2();
  cancelledList = new CargoV2Entities();
  cancelledPagination = new PaginationV2();
  activeTab = "cargo-v2-booking-success";
  pagination = new PaginationV2();
  isLoading = false;
  errorCause = "";
  searchFlightErrorMessage = "";
  isFlightNotFound = false;
  cargoIdToCancel = null as number | null;
  cargoIdToDelete = null as number | null;
  cargoNoForModal = null as string | null;
  cargoSuccessSummaryData = new CargoV2SuccessSummaryData();
  cargoDisputeSummaryData = new CargoV2DisputeSummaryData();
  cargoMinimumWeightSummaryData = new CargoV2MinimumWeightSummaryData();
  isLoadingCargoDispute = false;
  summaryInProcessValue = new CargoSummaryInProcessData();
  cargoFailedUnreadData = new CargoFailedUnread();
  rtcList = new RtcListEntities({
    pagination: new Pagination(1, 20, 0),
    data: []
  });
  rtcLoading = false;
  rtcDetail = new RtcData(
    JSON.parse(getDataSessionStorage(CARGO_V2_STORAGE_KEY.RTC_DETAIL))
  );
  commodityOptions: OptionsClass[] = [];
  commodityItem: OptionsClass = new OptionsClass();
  isOpenSelectCargoProduct = false;
  listProductCargo: OptionsClass[] = [];
  sourceSttFromLocalStorage: CargoV2DetailStt[] = [];
  nextFlightsData: FlightDetail[] = [];
  flowBooking = "";
  cargoProductList = [] as CargoV2ProductData[];
  clientParentData: ListClientParentData[] = [];
  clientParentPagination = new PaginationV2();
  isLoadingClient = false;
  searchFlightResult = new CargoV2SearchFlightResult();
  isLoadingSearchFlight = false;
  errorCauseSearchFlight = "";
  searchFlightParams = new CargoV2SearchFlightRequest();
  cargoHistory: CargoV2HistoryData[] = [];
  cargoDetailData: CargoV2Data = new CargoV2Data();
  form = new FormCargoV2(
    JSON.parse(getDataSessionStorage(CARGO_V2_STORAGE_KEY.FORM))
  );
  cargoDetailDataTable: any = [];
  isFirstLandingRtc = true;
  proofPhotoRebooking: any = JSON.parse(
    getDataSessionStorage(CARGO_V2_STORAGE_KEY.PROOF_PHOTO_REBOOKING) || "[]"
  );
  isLoadingSubmitSearchFlight = false;
  airportRouteTypeCache = null as AirportRouteTypeCache | null;

  @Mutation
  setAirportRouteTypeCache(data: AirportRouteTypeCache | null): void {
    this.airportRouteTypeCache = data;
  }

  @Mutation
  setIsLoadingSubmitSearchFlight(bool: boolean) {
    this.isLoadingSubmitSearchFlight = bool;
  }

  @Mutation
  setIsFirstLandingRtc(value: boolean): void {
    this.isFirstLandingRtc = value;
  }

  @Mutation
  setList(payload: CargoV2Entities): void {
    this.cargoV2List = payload;
  }

  @Mutation
  setInProgressList(payload: CargoV2Entities): void {
    this.inProgressList = payload;
    this.inProgressPagination = payload.pagination;
  }

  @Mutation
  setInProgressPagination(payload: Pagination): void {
    this.inProgressPagination = payload;
  }

  @Mutation
  setCargoIdToCancel(id: number | null): void {
    this.cargoIdToCancel = id;
  }

  @Mutation
  setCancelledList(payload: CargoV2Entities): void {
    this.cancelledList = payload;
    this.cancelledPagination = payload.pagination;
  }

  @Mutation
  setCancelledPagination(payload: Pagination): void {
    this.cancelledPagination = payload;
  }

  @Mutation
  setCargoIdToDelete(id: number | null): void {
    this.cargoIdToDelete = id;
  }

  @Mutation
  setCargoNoForModal(cargoNo: string | null): void {
    this.cargoNoForModal = cargoNo;
  }

  @Mutation
  setActiveTab(tab: string): void {
    this.activeTab = tab;
  }

  @Mutation
  setPagination(payload: Pagination): void {
    this.pagination = payload;
  }

  @Mutation
  setLoading(value: boolean): void {
    this.isLoading = value;
  }

  @Mutation
  setError(cause: string): void {
    this.errorCause = cause;
  }

  @Mutation
  setCargoSuccessSummaryData(payload: CargoV2SuccessSummaryData): void {
    this.cargoSuccessSummaryData = payload;
  }

  @Mutation
  setCargoDisputeSummaryData(payload: CargoV2DisputeSummaryData): void {
    this.cargoDisputeSummaryData = payload;
  }

  @Mutation
  setCargoMinimumWeightSummaryData(
    payload: CargoV2MinimumWeightSummaryData
  ): void {
    this.cargoMinimumWeightSummaryData = payload;
  }

  @Mutation
  setLoadingCargoDispute(value: boolean): void {
    this.isLoadingCargoDispute = value;
  }

  @Mutation
  setSummaryInProcess(value: CargoV2SummaryInProcessData): void {
    this.summaryInProcessValue = value;
  }

  @Mutation
  setCargoFailedUnreadData(data: CargoV2FailedUnread): void {
    this.cargoFailedUnreadData = data;
  }

  @Mutation
  setSearchFlightParams(payload: CargoV2SearchFlightRequest): void {
    this.searchFlightParams = payload;
  }

  @Mutation
  setSearchFlightResult(payload: CargoV2SearchFlightResult): void {
    this.searchFlightResult = payload;
  }

  @Mutation
  setLoadingSearchFlight(value: boolean): void {
    this.isLoadingSearchFlight = value;
  }

  @Mutation
  setErrorCauseSearchFlight(cause: string): void {
    this.errorCauseSearchFlight = cause;
  }
  @Mutation
  setRtcList(payload: RtcListEntities): void {
    this.rtcList = payload;
  }

  @Mutation
  setRtcLoading(value: boolean): void {
    this.rtcLoading = value;
  }

  @Mutation
  setRtcDetail(payload: RtcData): void {
    storeDatatoSessionStorage(
      CARGO_V2_STORAGE_KEY.RTC_DETAIL,
      new RtcData(payload)
    );
    this.rtcDetail = new RtcData(payload);
  }

  @Mutation
  setCommodityOptions(payload: OptionsClass[]): void {
    this.commodityOptions = payload;
  }

  @Mutation
  setCommodityItem(payload: OptionsClass): void {
    this.commodityItem = payload;
  }

  @Mutation
  setIsOpenSelectCargoProduct(payload: boolean): void {
    this.isOpenSelectCargoProduct = payload;
  }

  @Mutation
  setCargoProduct(payload: OptionsClass): void {
    this.form.productCargo = payload.value;
  }

  @Mutation
  setCargoProductList(data: CargoV2ProductData[] = []): void {
    this.cargoProductList = data;
  }

  @Mutation
  setCargoHistory(data: CargoV2HistoryData[]): void {
    this.cargoHistory = data;
  }

  @Mutation
  setCargoDetailData(data: CargoV2Data): void {
    this.cargoDetailData = data;
  }

  @Mutation
  setSearchFlightErrorMessage(message: string): void {
    this.searchFlightErrorMessage = message;
  }

  @Mutation
  setIsFlightNotFound(status: boolean): void {
    this.isFlightNotFound = status;
  }

  @Action
  async fetchList(params: CargoV2ListRequest): Promise<void> {
    this.setLoading(true);
    this.setError("");
    try {
      const presenter = container.resolve(CargoV2Presenter);
      const data = await presenter.getCargoV2List(params);
      this.setList(data);
      this.setPagination(data.pagination);
    } catch (e) {
      this.setError((e as Error)?.message || "Failed to fetch list");
    } finally {
      this.setLoading(false);
    }
  }

  @Action
  async fetchListInProgress(params: CargoV2ListRequest): Promise<void> {
    this.setLoading(true);
    this.setError("");
    try {
      const presenter = container.resolve(CargoV2Presenter);
      const data = await presenter.getCargoV2ListInProgress(params);
      this.setInProgressList(data);
    } catch (e) {
      this.setError(
        (e as Error)?.message || "Failed to fetch in-progress list"
      );
    } finally {
      this.setLoading(false);
    }
  }

  @Action
  async fetchListCancelled(params: CargoV2ListRequest): Promise<void> {
    this.setLoading(true);
    this.setError("");
    try {
      const presenter = container.resolve(CargoV2Presenter);
      const data = await presenter.getCargoV2ListCancelled(params);
      this.setCancelledList(data);
    } catch (e) {
      this.setError((e as Error)?.message || "Failed to fetch cancelled list");
    } finally {
      this.setLoading(false);
    }
  }

  @Action
  async cancelBooking(): Promise<void> {
    const id = this.cargoIdToCancel;
    if (id == null) return;
    this.setLoading(true);
    this.setError("");
    try {
      const presenter = container.resolve(CargoV2Presenter);
      await presenter.cancelBooking(id);
      this.setCargoIdToCancel(null);
    } catch (e) {
      this.setError((e as Error)?.message || "Cancel failed");
    } finally {
      this.setLoading(false);
    }
  }

  @Action
  async deleteBooking(): Promise<void> {
    const i18nInstance = createI18n({
      legacy: false,
      locale: AccountController.accountData.account_type_detail.countryCode.toLowerCase(),
      fallbackLocale: "id",
      globalInjection: false,
      messages: {
        en,
        translateId,
        my
      }
    });
    const translate = i18nInstance.global.t;
    const id = this.cargoIdToDelete;
    if (id == null) return;
    this.setLoading(true);
    this.setError("");
    MainAppController.showLoading();
    try {
      const presenter = container.resolve(CargoV2Presenter);
      await presenter.deleteBooking(id);
      MainAppController.showMessageModal(
        new ModalMessageEntities({
          title: translate("cargoV2.components.common.susccessDeleteDataTitle"),
          message: translate(
            "cargoV2.components.common.susccessDeleteDataMessage",
            {
              cargoNo: this.cargoNoForModal
            }
          ),
          textSuccess: "OK",
          onSubmit: () => {
            MainAppController.closeMessageModal();
            this.setCargoNoForModal("");
            router.push("/cargo-v2/booking-success");
          },
          image: "delete-success"
        })
      );
      this.setCargoIdToDelete(null);
    } catch (e) {
      this.setError((e as Error)?.message || "Delete failed");
    } finally {
      this.setLoading(false);
      MainAppController.closeLoading();
    }
  }

  @Action
  async fetchDetail(id: string | number): Promise<CargoV2Data> {
    this.setCargoDetailData(new CargoV2Data());
    this.setLoading(true);
    this.setError("");
    try {
      const presenter = container.resolve(CargoV2Presenter);
      const detailDataFromApi = await presenter.getCargoV2Detail(id);
      this.setCargoDetailData(detailDataFromApi);

      return detailDataFromApi;
    } catch (e) {
      this.setError((e as Error)?.message || "Failed to fetch detail");
      return new CargoV2Data();
    } finally {
      this.setLoading(false);
    }
  }

  @Action
  async getDetailCargoV2ForPrint(
    params: GetDetailCargoV2ForPrintParams
  ): Promise<CargoV2Data> {
    const { id, isPrint } = params;
    let { activity } = params;
    if (AccountController.accountData.account_type === "internal") {
      activity = CargoV2DetailActivityEnum.IS_INTERNAL;
    }
    if (isPrint) {
      MainAppController.showLoading();
      MainAppController.closeErrorMessage();
    }
    const presenter = container.resolve(CargoV2Presenter);
    return presenter
      .getCargoV2DetailForPrint(id, activity)
      .then((res: CargoV2Data) => {
        const country = AccountController.accountData?.countryCode ?? "ID";
        res["totalActualCargoGrossWeight"] = formatByCountry(Number(res.totalActualCargoGrossWeight), { type: "weight", country });
        res["totalActualCargoVolumeWeight"] = formatByCountry(Number(res.totalActualCargoVolumeWeight), { type: "weight", country });
        return res;
      })
      .catch((error: unknown) => {
        if (isPrint) {
          MainAppController.showErrorMessage(
            parsingErrorResponse(error, "Print Gagal !", () =>
              this.getDetailCargoV2ForPrint(params)
            )
          );
        }
        return Promise.reject(error);
      })
      .finally(() => {
        if (isPrint) {
          MainAppController.closeLoading();
        }
      }) as Promise<CargoV2Data>;
  }

  @Action
  async getCargoSuccessSummary(params: CargoV2ListRequest): Promise<void> {
    try {
      const presenter = container.resolve(CargoV2Presenter);
      const res = await presenter.getSuccessSummary(params);
      this.setCargoSuccessSummaryData(res);
    } catch {
      this.setCargoSuccessSummaryData(new CargoV2SuccessSummaryData());
    }
  }

  @Action
  async getCargoDisputeSummary(params: CargoV2ListRequest): Promise<void> {
    this.setLoadingCargoDispute(true);
    try {
      const presenter = container.resolve(CargoV2Presenter);
      const res = await presenter.getDisputeSummary(params);
      this.setCargoDisputeSummaryData(res);
    } catch {
      this.setCargoDisputeSummaryData(new CargoV2DisputeSummaryData());
    } finally {
      this.setLoadingCargoDispute(false);
    }
  }

  @Action
  async getCargoMinimumWeightSummary(
    params: CargoV2MinimumWeightSummaryApiRequest
  ): Promise<void> {
    this.setLoadingCargoDispute(true);
    try {
      const presenter = container.resolve(CargoV2Presenter);
      const res = await presenter.getMinimumVolumeSummary(params);
      this.setCargoMinimumWeightSummaryData(res);
    } catch {
      this.setCargoMinimumWeightSummaryData(
        new CargoV2MinimumWeightSummaryData()
      );
    } finally {
      this.setLoadingCargoDispute(false);
    }
  }

  @Action
  async downloadExcelCargoSummaryDispute(payload: {
    cargoType: string;
    params: CargoV2ListRequest;
  }): Promise<void> {
    const { cargoType, params } = payload;
    const request = new CargoV2DisputeDownloadRequest({
      startDate: params.startDate ?? "",
      endDate: params.endDate ?? "",
      hubIds: params.hubIds ?? "",
      cargoType: cargoType === "all" ? "" : cargoType
    });
    const presenter = container.resolve(CargoV2Presenter);
    await presenter.downloadExcelCargoDisputeSummary(request);
  }

  @Action
  async downloadMinimumVolume(params: CargoV2ListRequest): Promise<void> {
    const payload = new CargoV2MinimumWeightSummaryApiRequest({
      startDate: params.startDate ?? "",
      endDate: params.endDate ?? "",
      hubIds: params.hubIds ?? "",
      cargoType: "plane"
    });
    const presenter = container.resolve(CargoV2Presenter);
    await presenter.downloadMinimumVolume(payload);
  }

  @Action
  async downloadListCargoSuccess(
    payload: CargoV2DownloadListRequest
  ): Promise<void> {
    const presenter = container.resolve(CargoV2Presenter);
    await presenter.downloadListCargoSuccess(payload);
  }

  @Action
  async downloadListCargoFailed(params: CargoV2ListRequest): Promise<void> {
    const presenter = container.resolve(CargoV2Presenter);
    await presenter.downloadListCargoFailed(params);
  }

  @Action
  async downloadAwbReceiptSync(payload: DownloadAWBRequest): Promise<void> {
    const presenter = container.resolve(CargoV2Presenter);
    const receipt = await presenter.downloadAwbReceiptSync(payload);
    await this.getDetailCargoV2ForPrint({ 
      id: payload.id, 
      isPrint: true, 
      activity: AccountController.accountData.isInternalAccount 
        ? CargoV2DetailActivityEnum.IS_INTERNAL 
        : CargoV2DetailActivityEnum.IS_PRINT_AWB 
    });
    return receipt;
  }

  @Action
  async downloadAwbReceipt(payload: DownloadAWBRequest): Promise<void> {

    MainAppController.showLoading();
    try {
      if (FlagsPermissionCargoV2.permission_cargo_v2_download_awb_receipt_sync_enable.isEnabled()) {
        await this.downloadAwbReceiptSync(payload);
      } else {
      const presenter = container.resolve(CargoV2Presenter);
        await presenter.downloadAwbReceipt(payload);
        await sleep(500);
        ReportController.onGetListDownloadReport(TAB_SUCCESS_REPORT_TYPE);
        ReportController.setOpenDownloadRequest(true);
      }
    } catch (error) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(
          error,
          "Download Gagal !",
          () => this.downloadAwbReceipt(payload),
          () => MainAppController.closeErrorMessage()
        )
      );
    } finally {
      MainAppController.closeLoading();
    }
  }

  @Action
  async getCargoSummaryInProcess(
    params?: CargoSummaryInProcessRequest
  ): Promise<void> {
    const accountOrigin =
      AccountController.accountData.account_location?.city_code ?? "";
    const requestParams =
      params ??
      new CargoSummaryInProcessRequest({
        originCity: accountOrigin,
        destinationCity: "",
        destinationAirport: "",
        startDate: new Date(
          new Date().setDate(new Date().getDate() - 1)
        ).toLocaleDateString("fr-CA"),
        endDate: new Date().toLocaleDateString("fr-CA")
      });
    try {
      const presenter = container.resolve(CargoV2Presenter);
      const res = await presenter.getSummaryInProcess(requestParams);
      this.setSummaryInProcess(res);
    } catch {
      this.setSummaryInProcess(new CargoV2SummaryInProcessData());
    }
  }

  @Action
  async getCargoFailedUnread(params: FailedUnreadRequest): Promise<void> {
    try {
      const presenter = container.resolve(CargoV2Presenter);
      const data = await presenter.getCargoFailedUnread(params);
      this.setCargoFailedUnreadData(data);
    } catch {
      this.setCargoFailedUnreadData(new CargoV2FailedUnread());
    }
  }

  @Action
  async fetchReadyToCargoList(params: RequestRtcList): Promise<void> {
    this.setRtcLoading(true);
    this.setError("");
    try {
      const presenter = container.resolve(CargoV2Presenter);
      const data = await presenter.getReadyToCargoList(params);
      this.setRtcList(data);
    } catch (e) {
      this.setError((e as Error)?.message || "Failed to fetch RTC list");
      this.setRtcList(
        new RtcListEntities({ pagination: new Pagination(1, 20, 0), data: [] })
      );
    } finally {
      this.setRtcLoading(false);
    }
  }

  @Action
  public async checkEligible(payload: RequestCheckEligibleRtcV2) {
    const presenter = container.resolve(CargoV2Presenter);
    return presenter.checkEligible(payload);
  }

  @Action
  public async mapRtcDetailToCargoForm() {
    if (this.rtcDetail.id) {
      const rtcDetail = this.rtcDetail;
      const totalStt = rtcDetail.detail.reduce((prev: number, curr: any) => {
        if (curr?.sttDetails) return prev + curr.sttDetails.length;
        return prev + 1;
      }, 0);

      // generate data table to form with group
      this.onGenerateGroupDataTable(rtcDetail.bagOrStt);

      this.setForm({
        productCargo: rtcDetail.rtcCargoProductType,
        originAirportCode: rtcDetail.originCode,
        originCityCode: rtcDetail.originCode,
        destinationAirportCode: rtcDetail.destinationCode,
        destinationCityCode: new OptionsClass({
          code: rtcDetail.destinationCode,
          name: rtcDetail.destinationName,
          label: `${rtcDetail.destinationCode} - ${rtcDetail.destinationName}`,
          countryCode: rtcDetail.destinationCountryCode
        }),
        estTotalCargoGrossweigth: rtcDetail.totalSttGrossWeight,
        actualTotalCargoGrossweigth: rtcDetail.totalWeight,
        estTotalCargoVolumeweight: rtcDetail.totalSttVolumeWeight,
        partnerType: rtcDetail.partnerType,
        partnerName: rtcDetail.clientParentName || rtcDetail.partnerCode || "",
        totalStt,
        totalPiece: rtcDetail.totalPieces,
        cargoActualPiece: rtcDetail.totalPieces,
        cargoType: new OptionsClass({
          code: rtcDetail.cargoType,
          label: rtcDetail.cargoType,
          name: rtcDetail.cargoType,
          value: rtcDetail.cargoType
        }),
        rtcId: rtcDetail.id,
        isFromRtc: true,
        route:
          rtcDetail.originName && rtcDetail.destinationName
            ? `${rtcDetail.originName} - ${rtcDetail.destinationName}`
            : "",
        departureDate: rtcDetail.nextCargoFlightTime
          ? dateTimePayload(moment(rtcDetail.nextCargoFlightTime).toString())
          : "",
        cargoOverCutoffLimit: !rtcDetail.isMoreThanCutOffTime
      });

      this.onGenerateDominanCommodityGroup();
      this.onGenerateDefaultNog();
      this.setSourceFromLocalStorage(this.rtcDetail.detail as any);
      const groupBaggingNumber = groupBy(
        this.rtcDetail.detail,
        "baggingNumber"
      );
      const data = [];
      for (const [key, value] of Object.entries(groupBaggingNumber)) {
        if (key) {
          data.push({
            baggingNumber: key,
            bagGrossWeight: value[0].bagCustomGrossWeight || null,
            stt: value
          });
        }
      }
      storeDatatoSessionStorage("cargo-bag", data);
      this.setBagResult(data);
      const divider = getConfigDimensionDivider(rtcDetail.cargoType);
      const isMinimumVolumePerPiece = getConfigIsminimumVolumePerPiece(
        rtcDetail.cargoType
      );
      const minVolumePerPiece = getConfigMinimumVolumePerPiece(
        rtcDetail.cargoType
      );
      await this.calculateVolume(
        new CalculateVolumeApiRequestV2({
          calculateType: CALCULATE_TYPE.INIT,
          calculateRequest: new CalculateVolumeRequestV2({
            cargoType: rtcDetail.cargoType,
            totalPieces: rtcDetail.totalPieces,
            length: 90,
            width: 60,
            currentGrossWeight: rtcDetail.totalWeight,
            volumeWeightReweigh: this.form
              .totalAccumulationEstimationVolumeWeightDataTable,
            chargeableWeightReweigh: this.form
              .cargoTotalEstimateChargeableWeight,
            divider: divider,
            isMinimumVolumePerPiece: isMinimumVolumePerPiece,
            minVolumePerPiece: minVolumePerPiece
          })
        })
      );
      this.setForm({
        cargoTotalCustomChargeableWeight: Math.max(
          this.form.actualTotalCargoGrossweigth,
          this.form.actualTotalCargoVolumeweight
        )
      });
    }
    const cargoInputForm = JSON.parse(
      getDataSessionStorage(CARGO_V2_STORAGE_KEY.FORM) || "{}"
    );

    cargoInputForm.cargoProduct = this.form.productCargo;
    storeDatatoSessionStorage(CARGO_V2_STORAGE_KEY.FORM, cargoInputForm);
  }

  @Action
  public async getDetailReadyToCargo(params: { id: number; flow?: string }) {
    try {
      const presenter = container.resolve(CargoV2Presenter);
      // clear previous state to avoid stale reads
      this.setRtcDetail(new RtcData());
      const key = await presenter.getDetailReadyToCargo(params.id);
      const detail = JSON.parse(JSON.stringify(key));
      this.setRtcDetail(detail);

      this.setFlowBooking(params.flow || "");
      this.setForm({
        destinationCityCode: new OptionsClass({
          code: detail.destinationCode,
          label: `${detail.destinationCode} - ${detail.destinationName}`,
          name: detail.destinationName,
          countryCode: detail.destinationCountryCode
        })
      });

      if (detail.nextFlightsData?.[0]?.departureHour) {
        const result = detail.nextFlightsData.map((flightData: any) => {
          return new FlightDetail({
            ...flightData,
            DepartureDateTime: detail.nextCargoFlightTime
          });
        });
        this.setDetailNextFlightData(result);
      } else {
        this.setDetailNextFlightData(detail.nextFlightsData as any);
      }

      const cargoData = {
        type: detail.cargoType,
        status: detail.cargoType == "plane" ? "auto" : "manual"
      };
      this.setForm({
        cargoType: new OptionsClass({
          value: detail.cargoType
        }),
        isCargoPlaneManual: cargoData.type.match(/plane/gi)
          ? cargoData.status !== "auto"
          : false
      });
      if (cargoData.type === "plane") {
        this.setForm({
          isCargoDimensionOn: !flags.feature_hide_dimension_koli.isEnabled()
        });
      } else {
        this.setForm({ isCargoDimensionOn: false });
      }

      return detail;
    } catch (error) {
      this.setRtcDetail(new RtcData());
      return new RtcData();
    }
  }

  @Action
  public onGenerateDominanCommodityGroup(autoSetDominan = true) {
    // mapping each bagging's stt
    let mappingdata: BagOrSttDetail[] = this.form.bagOrStt.filter(
      (stt) => !stt.bagNo
    );

    const bags = this.form.bagOrStt.filter((bag) => !!bag.bagNo);

    for (const bag of bags) {
      for (const stt of bag.sttDetails) {
        mappingdata.push(stt);
      }
    }

    // filter result of mapping data by commodity group
    let getUniqueList: any = uniqBy(
      mappingdata.filter((item: BagOrSttDetail) => item.commodityGroupCode),
      "commodityGroupCode"
    );
    // get all commodity group even dg or non dg
    const getUniqueListAll: any = cloneDeep(getUniqueList);

    // filter result of mapping data by dg commodity group
    const dgDataFiltered = mappingdata.filter(
      (item: BagOrSttDetail) => item.commodityGroupIsDg
    );
    const quarantineDataFiltered = mappingdata.filter(
      (item: BagOrSttDetail) => item.commodityGroupIsQuarantine
    );
    if (dgDataFiltered.length) {
      mappingdata = dgDataFiltered;
      getUniqueList = uniqBy(
        dgDataFiltered.filter(
          (item: BagOrSttDetail) => item.commodityGroupCode
        ),
        "commodityGroupCode"
      );
    } else if (quarantineDataFiltered.length) {
      mappingdata = quarantineDataFiltered;
      getUniqueList = uniqBy(
        quarantineDataFiltered.filter(
          (item: BagOrSttDetail) => item.commodityGroupCode
        ),
        "commodityGroupCode"
      );
    }

    // count total duplicate commodity group
    const countGroupByCommodity = mappingdata.reduce(
      (accumulator: any, item: BagOrSttDetail) => {
        const numToAdd = !dgDataFiltered.length
          ? 1
          : item.commodityGroupIsDg
          ? 1
          : 0;
        const key = item.commodityGroupCode;
        accumulator[key] = (accumulator[key] ?? 0) + numToAdd;
        return accumulator;
      },
      {}
    );

    // convert object total to array of object
    const totalDataByCommodityGroup = Object.entries(
      countGroupByCommodity
    ).map((item: any[]) => ({ name: item[0], total: item[1] }));

    // find max of total
    const max = totalDataByCommodityGroup.reduce((prev: any, current: any) =>
      prev.total > current.total ? prev : current
    );

    // find all index if possible max is more than 1
    const maxIndexLocation = totalDataByCommodityGroup.reduce(
      (accumulator: any, currentValue, currentIndex) =>
        currentValue.total === max.total
          ? accumulator.concat(currentIndex)
          : accumulator,
      []
    );

    const commodityList = getUniqueListAll.map(
      (item: BagOrSttDetail) =>
        new OptionsClass({
          name: item.commodityGroupName,
          code: item.commodityGroupCode,
          value: item.commodityGroupCode,
          shcCode: item.shcCode,
          shcName: item.shcDescription,
          isDangerousGoods: item.commodityGroupIsDg,
          isQuarantine: item.commodityGroupIsQuarantine
        })
    );

    // if one max, will set default value
    if (maxIndexLocation.length === 1) {
      // get detail data of max
      const dominanData: BagOrSttDetail = getUniqueList.find(
        (data: BagOrSttDetail) => {
          return data.commodityGroupCode === max.name;
        }
      );

      // set to default value
      const dominan = new OptionsClass({
        name: dominanData.commodityGroupName,
        code: dominanData.commodityGroupCode,
        value: dominanData.commodityGroupCode,
        shcCode: dominanData?.shcCode,
        shcName: dominanData?.shcDescription,
        isDangerousGoods: dominanData?.commodityGroupIsDg,
        isQuarantine: dominanData?.commodityGroupIsQuarantine
      });

      if (autoSetDominan) {
        this.form.cargoCommodity = dominan;
      }

      this.form.shc = dominanData?.shcCode || "";
      this.form.shcName = dominanData?.shcDescription || "";
    }
    // if more than one max, will be empty and user select commodity
    else {
      if (!this.form.cargoCommodity?.name) {
        this.form.cargoCommodity = new OptionsClass();
        this.form.shc = "";
        this.form.shcName = "";
      }

      let defaultCommodity = new OptionsClass(commodityList[0]);

      // default commodity group = first dg ifhave dg but dominan is draw even dominan is non dg
      if (dgDataFiltered.length) {
        const commodityListDg = getUniqueList.map(
          (item: BagOrSttDetail) =>
            new OptionsClass({
              name: item.commodityGroupName,
              code: item.commodityGroupCode,
              value: item.commodityGroupCode,
              shcCode: item.shcCode,
              shcName: item.shcName,
              isDangerousGoods: item?.commodityGroupIsDg,
              isQuarantine: item?.commodityGroupIsQuarantine
            })
        );
        defaultCommodity = commodityListDg[0];
      }

      // if no dominan (draw) total
      const dominan = new OptionsClass({
        name: defaultCommodity.name,
        code: defaultCommodity.value,
        value: defaultCommodity.value,
        shcCode: defaultCommodity.shcCode,
        shcName: defaultCommodity.shcName,
        isDangerousGoods: defaultCommodity.isDangerousGoods,
        isQuarantine: defaultCommodity.isQuarantine
      });

      if (autoSetDominan) {
        this.form.cargoCommodity = dominan;
      }

      this.form.shc = defaultCommodity.shcCode || "";
      this.form.shcName = defaultCommodity?.shcName || "";
    }

    this.setCommodityOptions(commodityList);
  }

  @Action
  public onGenerateDefaultNog() {
    const items = this.form.bagOrStt.filter(
      (item: BagOrSttDetail) => item.commodityName && item.commodityName.trim()
    );
    if (!items.length) {
      this.setForm({ nog: "" });
      return;
    }

    const dgItems = items.filter(
      (item: BagOrSttDetail) => item.isDangerousGoods
    );
    const quarantineItems = items.filter(
      (item: BagOrSttDetail) => item.isQuarantine
    );

    const source = dgItems.length
      ? dgItems
      : quarantineItems.length
      ? quarantineItems
      : items;
    const commodityName = getDominantCommodityName(source);

    const hasBosspack = this.form.bagOrStt.some(
      (item: BagOrSttDetail) => item.productType === "BOSSPACK"
    );
    const nog = hasBosspack ? `BOSSPACK-${commodityName}` : commodityName;
    this.setForm({ nog });
  }

  @Action
  public async fetchLastIdCargoRetryCargo(payload: CargoV2ListRequest) {
    if (payload.type === "retry-cargo") {
      const presenter = container.resolve(CargoV2Presenter);
      return await presenter.getLastIdRetryCargo(payload);
    } else {
      const presenter = container.resolve(CargoV2Presenter);
      return await presenter.getLastIdCargo(payload);
    }
  }

  @Action
  public getCargoProductList(status: string) {
    const presenter = container.resolve(CargoV2Presenter);
    return presenter.getCargoProductList(status);
  }

  @Action
  public updateCommodityItem(value: OptionsClass) {
    this.setCommodityItem(value);
  }

  @Action
  public updateCargoCommodity(value: OptionsClass) {
    this.setCommodityItem(value);
    const cargoInputData = this.form;
    this.setForm({
      ...cargoInputData,
      cargoCommodity: cargoInputData.cargoCommodity,
      shc: cargoInputData.cargoCommodity.shcCode,
      shcName: cargoInputData.cargoCommodity.shcName
    });
  }

  @Action
  public updateNog(value: string) {
    this.setForm({ nog: value });
  }

  @Action
  public updateSelectedCargoProduct(value: string) {
    this.setForm({
      productCargo: value
    });
  }

  @Action
  public async createBooking(payload: CreateCargoV3ApiRequest) {
    const presenter = container.resolve(CargoV2Presenter);
    return presenter.createCargo(payload);
  }

  @Action
  public onEditCargo(payload: EditCargoApiRequest) {
    MainAppController.showLoading();
    MainAppController.closeErrorMessage();
    const presenter = container.resolve(CargoV2Presenter);
    return presenter
      .editCargoV3(payload)
      .finally(() => MainAppController.closeLoading());
  }

  @Action
  public getDownloadData(params: { id: number; type: string, filename?: string }) {
    MainAppController.showLoading();
    MainAppController.closeErrorMessage();
    const presenter = container.resolve(CargoV2Presenter);
    return presenter
      .getDownloadData(params.id, params.type, params.filename)
      .then((res: string) => {
        return {
          data: res,
          success: true
        };
      })
      .catch((error: any) => {
        MainAppController.showErrorMessage(
          parsingErrorResponse(error, "Download Gagal !", () => {
            MainAppController.closeErrorMessage();
            this.getDownloadData(params);
          })
        );
        return {
          data: "",
          success: false
        };
      })
      .finally(() => MainAppController.closeLoading());
  }

  @Action
  public getRTCListClientParent(params: CargoV2ListClientParentApiRequest) {
    this.setLoadingClient(true);
    const presenter = container.resolve(CargoV2Presenter);
    presenter
      .getRTCListClientParent(params)
      .then((res: ListClientParentEntities) => {
        this.setClientParentData(res.data);
        this.setClientParentPagination(res.pagination);
      })
      .catch(() => {
        this.setClientParentData([]);
      })
      .finally(() => {
        this.setLoadingClient(false);
      });
  }

  @Mutation
  public setClientParentData(data: ListClientParentData[]) {
    this.clientParentData = data;
  }

  @Mutation
  public setClientParentPagination(pagination: PaginationV2) {
    this.clientParentPagination = pagination;
  }

  @Mutation
  setLoadingClient(value: boolean): void {
    this.isLoadingClient = value;
  }

  @Action
  public getAwbValidation(payload: AwbValidationApiRequest) {
    const presenter = container.resolve(CargoV2Presenter);
    return presenter.getAwbValidation(payload);
  }

  @Action
  async calculateVolumeForSearchFlight() {
    const cargoType = this.form.cargoType?.value || "plane";
    const totalPieces = this.form.cargoActualPiece || 0;
    const currentGrossWeight = this.form.actualTotalCargoGrossweigth || 0;
    const chargeableWeightReweigh =
      this.form.cargoTotalEstimateChargeableWeight || 0;

    return await this.calculateVolume(
      new CalculateVolumeApiRequestV2({
        calculateType: this.calculateType || CALCULATE_TYPE.INIT,
        calculateRequest: new CalculateVolumeRequestV2({
          cargoType,
          totalPieces,
          length: this.form.actualDimension?.cargoActualLengthDimension ?? 90,
          width: this.form.actualDimension?.cargoActualWidthDimension ?? 60,
          currentGrossWeight,
          volumeWeightReweigh: this.form
            .totalAccumulationEstimationVolumeWeightDataTable,
          chargeableWeightReweigh,
          divider: getConfigDimensionDivider(cargoType),
          minVolumePerPiece: getConfigMinimumVolumePerPiece(cargoType, "auto"),
          isMinimumVolumePerPiece: getConfigIsminimumVolumePerPiece(
            cargoType,
            "auto"
          )
        })
      })
    );
  }

  searchFlightApiController = new AbortController();
  @Mutation
  public setSearchFlightApiController(value = new AbortController()) {
    this.calculateVolumeApiController = value;
  }
  @Action
  async fetchSearchFlight(): Promise<void> {
    window.requestAnimationFrame(() => {
      this.setLoadingSearchFlight(true);
    });
    this.setErrorCauseSearchFlight("");
    const currentController = new AbortController();
    try {
      const presenter = container.resolve(CargoV2Presenter);
      this.calculateVolumeApiController?.abort();
      this.setCalculateVolumeApiController(currentController);
      const result = await presenter.searchFlight(
        new CargoV2SearchFlightRequest({
          ...this.searchFlightParams,
          signal: currentController.signal
        })
      );
      this.setSearchFlightResult(result);
    } catch (e) {
      if ((e as any)?.code === "ERR_CANCELED") return;
      this.setSearchFlightResult(new CargoV2SearchFlightResult());

      // Skenario Offline
      if (!(e as any)?.response) {
        this.setErrorCauseSearchFlight("internet");
        console.error(e);
        return;
      }

      // Skenario not found
      if ((e as any)?.response?.status === 404) {
        this.setErrorCauseSearchFlight("server");
        this.setIsFlightNotFound(true);
        console.error(e);
        return;
      }

      // Skenario (API error bilingual 400, dll)
      this.setErrorCauseSearchFlight("server");
      const errorEntities = parsingErrorResponse(e);
      this.setSearchFlightErrorMessage(errorEntities.message || "");

      console.error(e);
    } finally {
      this.setLoadingSearchFlight(false);
    }
  }

  @Action
  async submitFromSearchFlight(flight: CargoV2SearchFlight) {
    this.setIsLoadingSubmitSearchFlight(true);
    MainAppController.showLoading();
    try {
      const calculateResult = await this.calculateVolumeForSearchFlight();
      if (!calculateResult) {
        return;
      }
      const cutoff = moment(this.rtcDetail.cutOffTime, "HH:mm");
      const isOverCutoffTime = cutoff.isValid() && moment().isAfter(cutoff);
      this.setForm({
        cargoTotalChargeableWeight: calculateResult.chargeableWeight,
        cargoTotalCustomChargeableWeight: calculateResult.chargeableWeight,
        cargoTotalEstimateChargeableWeight: this.form
          .cargoTotalEstimateChargeableWeight,
        actualTotalCargoVolumeweight: calculateResult.volumeWeight,
        actualDimension: new ActualDimensionData({
          ...this.form.actualDimension,
          cargoActualHeightDimension: calculateResult.height
        }),
        originAirportCode: flight.originAirportCode,
        destinationAirportCode: flight.destinationAirportCode,
        cargoOverCutoffLimit: this.form.cargoOverCutoffLimit || isOverCutoffTime,
        isFlightVia: flight.isFlightVia ?? false,
        isTransit: flight.isTransit ?? false,
      });

      const flightRequestList: FlightRequest[] = flight.itineraries.map(
        (item, index) =>
          new FlightRequest({
            flightNo: item.flightNo,
            flightDateTime: toFlightDateTimeStr(item.departureDate),
            flightOrigin: item.originAirportCode,
            flightDestination: item.destinationAirportCode,
            aircraftInfo: item.aircraftInfo,
            remainingCapacity: item.remainingCapacity,
            remainingCapacityAllotment: item.remainingCapacityAllotment,
            remainingCapacityFreesales: item.remainingCapacityFreesales,
            isFlightVia: item.isFlightVia ?? false,
            isTransit: item.isTransit ?? false,
            sequence: item.sequence
          })
      );

      const bookingPayload = new BookingPayloadData({
        awbNo: this.form.bookingPayload?.awbNo ?? "",
        shcCode: this.form.bookingPayload?.shcCode || this.form.shc || "",
        flightRequest: flightRequestList
      });

      const payload = new CreateCargoV3ApiRequest({
        ...this.form,
        cargoType: new OptionsClass({ value: "plane" }),
        cargoRtcTurnAuto: this.form.isFromRtc,
        isCargoPlaneManual: false,
        isNewCalculation: flags.feature_hide_dimension_koli.isEnabled(),
        isUseNewCalculation: flags.feature_hide_dimension_koli.isEnabled(),
        isCargoDimensionOn: !flags.feature_hide_dimension_koli.isEnabled(),
        bookingPayload,
        calculateType: this.calculateType
      });

      const resp = await this.createBooking(payload);
      return resp.cargoNo;
    } finally {
      this.setIsLoadingSubmitSearchFlight(false);
      MainAppController.closeLoading();
    }
  }

  @Action
  public getDetailRtc(id: number) {
    const presenter = container.resolve(CargoV2Presenter);
    return presenter.getDetailReadyToCargo(id);
  }

  detailRtc = new RtcData();
  @Mutation
  public setDetailRtc(value = new RtcData()) {
    this.detailRtc = value;
  }

  @Mutation
  setForm(payload: Partial<FormCargoV2>): void {
    this.form = new FormCargoV2({ ...this.form, ...payload });
    storeDatatoSessionStorage(CARGO_V2_STORAGE_KEY.FORM, this.form);
  }

  @Mutation
  resetForm(): void {
    this.form = new FormCargoV2();
    storeDatatoSessionStorage(CARGO_V2_STORAGE_KEY.FORM, this.form);
  }

  @Mutation
  setCargoDetailDataTable(payload: any): void {
    this.cargoDetailDataTable = payload;
  }

  public calculateType: string = JSON.parse(
    getDataSessionStorage(CARGO_V2_STORAGE_KEY.CALCULATE_TYPE) || "{}"
  );

  @Action
  public async getCargoCommodityList() {
    this.setLoading(true);
    try {
      const presenter = container.resolve(CargoV2Presenter);
      const data = await presenter.getCargoCommodityList(1, 100, "");
      const options = data.data.map(
        (item: any) =>
          new OptionsClass({
            name: item.commodityGroupName,
            value: item.commodityGroupCode,
            id: item.commodityGroupId
          })
      );

      this.setCommodityOptions(options);

      if (this.rtcDetail.detail.length) {
        const data = this.commodityOptions.find((item: OptionsClass) =>
          this.rtcDetail.detail.some(
            (detail) => detail.commodityGroupCode == item.value
          )
        );

        if (data) {
          this.setForm(new FormCargoV2({ ...this.form, cargoCommodity: data }));
        }
      }
    } catch (e) {
      console.error(e);
    } finally {
      this.setLoading(false);
    }
  }

  @Action
  public async getCargoHistory(sttId: string) {
    this.setLoading(true);
    try {
      const presenter = container.resolve(CargoV2Presenter);
      const data = await presenter.getCargoHistory(sttId);
      this.setCargoHistory(data);
    } catch (e) {
      console.error(e);
    } finally {
      this.setLoading(false);
    }
  }

  calculateVolumeApiController = new AbortController();
  @Mutation
  public setCalculateVolumeApiController(value = new AbortController()) {
    this.calculateVolumeApiController = value;
  }
  @Action
  async calculateVolume(payload: CalculateVolumeApiRequestV2) {
    if (!this.form.bagOrStt.length) {
      this.form.actualTotalCargoVolumeweight = 0;
      this.form.cargoTotalCustomChargeableWeight = 0;
      this.setUploadProofPhoto(false);
      return;
    }

    const currentController = new AbortController();
    try {
      this.setIsLoadingCalculateVolume(true);
      this.calculateVolumeApiController?.abort();
      this.setCalculateVolumeApiController(currentController);

      const {
        cargoType,
        isValidAwbManual,
        cargoActualPiece,
        actualDimension: { cargoActualHeightDimension },
        actualTotalCargoGrossweigth,
        actualTotalCargoVolumeweight,
        cargoTotalEstimateChargeableWeight
      } = this.form;

      // check payload from params or form
      const moda = payload.calculateRequest.cargoType || cargoType.value;
      const currentGrossWeight =
        payload.calculateRequest.currentGrossWeight ||
        actualTotalCargoGrossweigth;
      const volumeWeightReweigh = Math.round(
        payload.calculateRequest.volumeWeightReweigh ||
          actualTotalCargoVolumeweight
      );
      const chargeableWeightReweigh =
        payload.calculateRequest.chargeableWeightReweigh ||
        cargoTotalEstimateChargeableWeight;

      const totalPieces =
        payload.calculateRequest.totalPieces || cargoActualPiece;

      const planeAuto = moda !== "plane" || isValidAwbManual ? "" : "auto";

      // config
      const divider = getConfigDimensionDivider(moda);
      const isMinimumVolumePerPiece = getConfigIsminimumVolumePerPiece(
        moda,
        planeAuto
      );
      const minVolumePerPiece = getConfigMinimumVolumePerPiece(moda, planeAuto);

      const isInit = payload.calculateType === CALCULATE_TYPE.INIT;
      const isChangeModa = payload.calculateType === CALCULATE_TYPE.CHANGE_MODA;

      const shouldUpdateInitData = isInit || isChangeModa;
      const shouldUpdateVolume =
        shouldUpdateInitData && isMinimumVolumePerPiece;

      if (shouldUpdateVolume) {
        delete payload.calculateRequest.length;
        delete payload.calculateRequest.width;
      }

      if (payload.calculateType === "INIT") {
        this.setOnChangeDimension({
          pieces: this.form.cargoActualPiece,
          length: payload.calculateRequest.length,
          width: payload.calculateRequest.width,
          height: Math.max(1, payload.calculateRequest.height)
        });
        this.setInitCalculateVolumeData();
      }

      const res = await container.resolve(CargoV2Presenter).calculateVolume(
        new CalculateVolumeApiRequestV2({
          ...payload,
          calculateRequest: new CalculateVolumeRequestV2({
            ...payload.calculateRequest,
            cargoType: moda,
            totalPieces,
            height: cargoActualHeightDimension,
            currentGrossWeight,
            volumeWeightReweigh,
            chargeableWeightReweigh,
            divider,
            isMinimumVolumePerPiece,
            minVolumePerPiece,
            totalStt: this.totalSttDataTable,
            maxDisputeWeight: this.maxDisputeWeight,
            currentChargeableWeight: isMinimumVolumePerPiece
              ? this.initCalculateVolumeData.chargeableWeight
              : payload.calculateRequest.chargeableWeightReweigh
          }),
          signal: currentController.signal
        })
      );

      this.setCalculateVolumeData(
        new CalculateVolume({ ...res, calculateType: payload.calculateType })
      );

      this.mappingCalculateVolume(shouldUpdateVolume);

      if (shouldUpdateInitData) {
        this.setInitCalculateVolumeData(
          new CalculateVolume({
            ...this.initCalculateVolumeData,
            ...res,
            calculateType: payload.calculateType,
            chargeableWeight: isMinimumVolumePerPiece
              ? res.chargeableWeight
              : payload.calculateRequest.chargeableWeightReweigh
          })
        );
      }

      return res;
    } catch (error) {
      if ((error as any)?.code === "ERR_CANCELED") return;
      MainAppController.showErrorMessage(
        parsingErrorResponse(
          error,
          "Kalkulasi Berat Volume Gagal!",
          () => {
            MainAppController.closeErrorMessage();
            this.calculateVolume(payload);
          },
          () => {
            MainAppController.closeErrorMessage();
            this.calculateVolume(payload);
          }
        )
      );
      throw error;
    } finally {
      if (this.calculateVolumeApiController === currentController) {
        this.setIsLoadingCalculateVolume(false);
      }
    }
  }

  @Mutation
  public setOnChangeDimension({
    length,
    width,
    height,
    pieces
  }: DimensionPieces) {
    this.form = new FormCargoV2({
      ...this.form,
      actualDimension: new ActualDimensionData({
        cargoActualHeightDimension: height,
        cargoActualLengthDimension: length,
        cargoActualWidthDimension: width
      }),
      dimensions: [
        new DimensionPieces({
          length,
          width,
          height,
          pieces
        })
      ]
    });
  }

  @Mutation
  public setCalculateVolumeData(value = new CalculateVolume()) {
    if ([CALCULATE_TYPE.INIT].includes(value.calculateType))
      this.isDimensionChanged = false;
    this.calculateVolumeData = value;
    this.calculateType = value.calculateType;
    storeDatatoSessionStorage(
      SESSION_STORAGE_CARGO_KEY.CALCULATE_TYPE,
      value.calculateType
    );
    storeDatatoSessionStorage(
      SESSION_STORAGE_CARGO_KEY.CALCULATE_VOLUME,
      value
    );
  }

  @Mutation
  public setInitCalculateVolumeData(value = new CalculateVolume()) {
    this.initCalculateVolumeData = value;
    this.form.currentChargeableWeight = value.chargeableWeight || 0;
    storeDatatoSessionStorage(
      SESSION_STORAGE_CARGO_KEY.INIT_CALCULATE_TYPE,
      value
    );
  }

  calculateVolumeData = new CalculateVolume(
    JSON.parse(
      getDataSessionStorage(SESSION_STORAGE_CARGO_KEY.CALCULATE_VOLUME) || "{}"
    )
  );
  initCalculateVolumeData = new CalculateVolume(
    JSON.parse(
      getDataSessionStorage(SESSION_STORAGE_CARGO_KEY.INIT_CALCULATE_TYPE) ||
        "{}"
    )
  );
  isLoadingCalculateVolume = false;

  @Mutation
  public setIsLoadingCalculateVolume(bool = false) {
    this.isLoadingCalculateVolume = bool;
  }

  @Action
  public mappingCalculateVolume(shouldUpdateDimension = false) {
    let width = this.form.actualDimension.cargoActualWidthDimension;
    let length = this.form.actualDimension.cargoActualLengthDimension;

    if (shouldUpdateDimension) {
      width = this.calculateVolumeData.width;
      length = this.calculateVolumeData.length;
      this.setIsDimensionChanged(false);
    }

    this.setOnChangeDimension({
      pieces: this.form.cargoActualPiece,
      height: this.calculateVolumeData.height,
      length,
      width
    });

    this.form.actualTotalCargoVolumeweight = Math.max(
      1,
      this.calculateVolumeData.volumeWeight
    );

    this.form.cargoTotalCustomChargeableWeight = this.calculateVolumeData.chargeableWeight;

    this.setUploadProofPhoto(this.calculateVolumeData.isUploadProofPhoto);
  }

  public isDimensionChanged = false;
  @Mutation
  public setIsDimensionChanged(val: boolean) {
    this.isDimensionChanged = val;
  }

  public isUploadProofPhoto: boolean =
    getDataSessionStorage(SESSION_STORAGE_CARGO_KEY.UPLOAD_PROOF_PHOTO_KEY) ===
    "true";

  @Mutation
  public setUploadProofPhoto(value: boolean) {
    this.isUploadProofPhoto = value;
    storeDatatoSessionStorage(
      SESSION_STORAGE_CARGO_KEY.UPLOAD_PROOF_PHOTO_KEY,
      value
    );
  }

  @Action
  checkNeedRefreshData(params: {
    data: RtcData;
    onSubmit: () => void;
  }): boolean {
    const { data, onSubmit } = params;

    const { isMoreThanCutOffTime, cutOffTime } = data;
    if (!isMoreThanCutOffTime) {
      const [hours, minutes, seconds] = cutOffTime?.split(":").map(Number);
      const rtcDate = new Date(
        new Date().setHours(hours, minutes, seconds)
      ).getTime();
      const now = new Date().getTime();
      if (rtcDate < now) {
        MainAppController.showMessageModal(
          new ModalMessageEntities({
            image: "sync-paket",
            title: "Ada pembaharuan data, silakan cek kembali",
            textSuccess: "Oke",
            onSubmit
          })
        );
        return false;
      }
    }
    return true;
  }

  @Mutation
  public setSourceFromLocalStorage(data: CargoV2DetailStt[]) {
    this.sourceSttFromLocalStorage = data;
  }

  @Mutation
  public setBagResult(data: any[]) {
    storeDatatoSessionStorage("cargo-bag", data);
  }

  @Mutation
  public setFlowBooking(value: string) {
    this.flowBooking = value;
    storeDatatoSessionStorage("flow-booking", value);
  }

  @Mutation
  public setDetailNextFlightData(data: FlightDetail[]) {
    this.nextFlightsData = data;
    storeDatatoSessionStorage("next-rtc-flights-data", data);
  }

  @Mutation
  public setShowSelectAirportToLocalStorage(bool: boolean) {
    storeDatatoSessionStorage("show-select-airport", bool);
  }

  @Mutation
  public setDefaultDepartureArrivalNonPlane() {
    this.form.departureDate = dateTimePayload(moment().toString());
    this.form.arrivalDate = dateTimePayload(
      moment()
        .add(6, "days")
        .toString()
    );
  }

  @Action
  getCargoTransportType(payload: { origin: string; destination: string }) {
    const presenter = container.resolve(CargoV2Presenter);
    return presenter.getCargoTransportType(payload.origin, payload.destination);
  }

  @Action
  public getDetailRetryCargo(id: string) {
    const presenter = container.resolve(CargoV2Presenter);
    return presenter.getDetailRetryCargo(id);
  }

  @Action
  public scan(payload: ScanApiRequest) {
    const presenter = container.resolve(CargoV2Presenter);
    return presenter.scan(payload);
  }

  get totalBagDataTable() {
    return this.form.bagOrStt.filter((bag) => !!bag.bagNo).length;
  }

  get totalSttDataTable() {
    return this.form.bagOrStt.filter((bag) => !bag.bagNo).length;
  }

  @Action
  onGenerateGroupDataTable(data: BagOrSttDetail[]) {
    // Preserve recency order while grouping by bagNo
    type GroupRow = BagOrSttDetail & {
      sttDetails?: BagOrSttDetail[];
      orderIndex: number;
    };
    const rowsMap = new Map<string, GroupRow>();
    const rowsList: GroupRow[] = [];

    data.forEach((item, index) => {
      // Check if it is a bag based on bagNo being present and not "-"
      const hasBag = item.bagNo && item.bagNo !== "-" && item.bagNo !== "";

      if (hasBag) {
        const key = `BAG:${item.bagNo}`;
        const existing = rowsMap.get(key);

        const detailsToAdd =
          item.sttDetails && item.sttDetails.length > 0
            ? item.sttDetails
            : [item];

        if (!existing) {
          const bagData = item.bagData;
          const row: GroupRow = {
            ...item,
            bagNo: item.bagNo,
            chargeableWeight:
              bagData?.bagTotalChargeableWeight || item.chargeableWeight || 0,
            sttDetails: [...detailsToAdd],
            orderIndex: index
          };
          rowsMap.set(key, row);
          rowsList.push(row);
        } else {
          existing.sttDetails = existing.sttDetails || [];
          existing.sttDetails.push(...detailsToAdd);

          existing.orderIndex = Math.min(existing.orderIndex, index);
          existing.chargeableWeight =
            item.bagData?.bagTotalChargeableWeight ||
            existing.chargeableWeight ||
            0;
        }
      } else {
        const key = `STT:${item.sttNo || index}`;
        const row: GroupRow = {
          ...item,
          sttDetails: [item],
          orderIndex: index
        };
        rowsMap.set(key, row);
        rowsList.push(row);
      }
    });

    // Sort so that lower orderIndex (more recent at top) comes first
    rowsList.sort((a, b) => a.orderIndex - b.orderIndex);

    this.setForm({ bagOrStt: rowsList });
    this.setCargoDetailDataTable(rowsList);
  }

  @Action
  onDeleteBagOrStt(bagOrStt: BagOrSttDetail[]) {
    const formRows = [...this.form.bagOrStt];

    const bagNos = bagOrStt.map((i) => i.bagNo).filter(Boolean);

    const sttNos = bagOrStt.map((i) => i.sttNo).filter(Boolean);

    const filtered = formRows.filter((row) => {
      // remove bag
      if (row.bagNo && bagNos.includes(row.bagNo)) return false;

      // remove stt without bag
      if (
        !row.bagNo &&
        row.sttDetails?.some((stt) => sttNos.includes(stt.sttNo))
      ) {
        return false;
      }

      return true;
    });

    this.setForm({ bagOrStt: filtered });
  }

  // GENESIS-24946: resolved plane booking limits (gross / volume / pieces).
  // Single source of truth shared with the dispute-form "Maksimal ..." text.
  get planeBookingLimits() {
    return resolvePlaneBookingLimits(
      this.airportRouteTypeCache,
      this.form.cargoType.value,
      this.form.originCityCode,
      this.form.destinationCityCode.code || ""
    );
  }

  // GENESIS-24945: Horde route-type returns the three resolved booking limits
  // for the current city pair; refreshed whenever cargo type / origin /
  // destination city changes (see cargo-dispute-form watcher). The BE already
  // decides domestic/international, so FE just caches the three numbers and
  // falls back silently to the shared helpers on API failure/incomplete data.
  @Action
  public async refreshAirportRouteType(): Promise<void> {
    const originCityCode = this.form.originCityCode;
    const destinationCityCode = this.form.destinationCityCode.code || "";
    if (
      !isPlaneRouteWithKnownCities(
        this.form.cargoType.value,
        originCityCode,
        destinationCityCode
      )
    ) {
      return;
    }

    const key = buildAirportRouteTypeCacheKey(
      originCityCode,
      destinationCityCode
    );
    const routeType = await CargoController.getAirportRouteType({
      originCityCode,
      destinationCityCode
    });
    if (!routeType) return;

    this.setAirportRouteTypeCache({
      key,
      maxGrossWeightKg: routeType.maxGrossWeightKg,
      maxVolumeWeightKg: routeType.maxVolumeWeightKg,
      maxPieces: routeType.maxPieces
    });
  }

  get isGrossWeightInputError() {
    return (
      this.form.actualTotalCargoGrossweigth > this.planeBookingLimits.maxGross
    );
  }

  get isVolumeWeightError() {
    return (
      this.form.actualTotalCargoVolumeweight > this.planeBookingLimits.maxVolume
    );
  }

  get isPiecesInputError() {
    return this.form.cargoActualPiece > this.planeBookingLimits.maxPieces;
  }

  get flightsData() {
    if (
      this.rtcDetail.nextCargoFlightTime &&
      new Date(this.rtcDetail.nextCargoFlightTime).getFullYear() !== 1
    ) {
      const flightsData = [this.rtcDetail.nextRtcFlightConfig];
      if (flightsData[0]?.cargo_flight_transit?.length) {
        for (const flight of flightsData[0].cargo_flight_transit) {
          flightsData.push(flight);
        }
      }
      return flightsData.map((flight: any, index) => {
        const dayToAdd =
          index === 0 ? 0 : flightsData[index - 1].cargo_flight_day_transit;
        const flightDate = new Date(
          new Date().setDate(
            new Date().getDate() +
              flight.cargo_flight_day_transit +
              dayToAdd +
              1
          )
        );
        return new FlightRequest({
          flightOrigin: flight.cargo_flight_origin,
          flightDestination: flight.cargo_flight_destination,
          flightDateTime:
            formatDateNormal(flightDate, "YYYY-MM-DD") +
            ` ${flight.cargo_flight_departure_hour}`,
          flightThresholdTime: flight.cargo_flight_treshold
        });
      });
    }

    const flightsData = this.rtcDetail.flightsData;
    return flightsData.map((flight, index) => {
      const dayToAdd =
        index === 0 ? 0 : flightsData[index - 1].flightDayTransit;
      const flightDate = new Date(
        new Date().setDate(
          new Date().getDate() + flight.flightDayTransit + dayToAdd
        )
      );
      return new FlightRequest({
        flightOrigin: flight.airportCodeOrigin,
        flightDestination: flight.airportCodeDestination,
        flightDateTime:
          formatDateNormal(flightDate, "YYYY-MM-DD") +
          ` ${flight.departureHour}`,
        flightThresholdTime: flight.thresholdTime
      });
    });
  }

  get departureDate() {
    if (
      this.rtcDetail.nextCargoFlightTime &&
      new Date(this.rtcDetail.nextCargoFlightTime).getFullYear() !== 1
    )
      return formatDateNormal(
        this.rtcDetail.nextCargoFlightTime,
        "YYYY-MM-DD HH:mm:ss"
      );
    if (!this.flightsData.length) return "";
    return this.flightsData[0]?.flightDateTime || "";
  }

  get arrivalDate() {
    return formatDateNormal(
      new Date(
        new Date().setDate(
          new Date(
            this.flightsData[this.flightsData.length - 1].flightDateTime
          ).getDate() + 1
        )
      ),
      "YYYY-MM-DD 00:00:00"
    );
  }

  get cargoOverCutoffLimit() {
    return (this.rtcDetail.nextCargoFlightTime &&
      new Date(this.rtcDetail.nextCargoFlightTime).getFullYear() !== 1) ||
      this.rtcDetail.cutOffTimeExceededWithoutNextConfig
      ? true
      : false;
  }

  @Mutation
  setProofPhotoRebooking(proofPhoto: string[]): void {
    this.proofPhotoRebooking = proofPhoto;
    storeDatatoSessionStorage(
      CARGO_V2_STORAGE_KEY.PROOF_PHOTO_REBOOKING,
      this.proofPhotoRebooking
    );
  }

  // error dispute
  get maxDisputeWeight(): number {
    const whitelist: number[] = FlagsPermissionCargoV2.config_whitelist_client_max_dispute_weight.getValue() as number[];
    const hasWhitelisted = this.form.bagOrStt.some((item: BagOrSttDetail) =>
      item.sttDetails?.some((e: BagOrSttDetail) =>
        whitelist.includes(e.sttClientId)
      )
    );
    return hasWhitelisted
      ? 0
      : FlagsPermissionCargoV2.config_max_dispute_weight.getValue();
  }
  get isExceedMaxDisputeWeight(): boolean {
    return this.calculateVolumeData.isMaximumDisputeWeight;
  }
  get isBagOnlyExceedMaxDisputeWeight() {
    return Boolean(
      this.calculateVolumeData.isMaximumDisputeWeight &&
        this.form.bagOrStt.length &&
        !this.totalSttDataTable
    );
  }
}

export const CargoV2Controller = getModule(CargoV2Store);
